__turbopack_context__.v({
  "buttonLink": "B8OKEW_buttonLink",
  "icon": "B8OKEW_icon",
  "root": "B8OKEW_root",
});
